import React, { PropsWithChildren } from 'react';
import { Text } from 'core/components';

type ClickableTextProps = PropsWithChildren<{
  onClick?: () => void;
}>;

function ClickableText({ children, onClick }: ClickableTextProps) {
  return (
    <Text textDecoration="underline" onClick={onClick} style={{ cursor: 'pointer' }}>
      {children}
    </Text>
  );
}

export default ClickableText;
